import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';

const LanguageToggle = () => {
  const { language, setLanguage } = useLanguage();

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'es' : 'en');
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center text-gray-700 hover:text-teal-600 transition-all duration-300 px-3 py-2 rounded-lg hover:bg-gray-50/80"
      aria-label="Toggle language"
    >
      <Globe className="h-5 w-5 mr-1" />
      <span className="uppercase text-sm font-medium">{language === 'en' ? 'ES' : 'EN'}</span>
    </button>
  );
};

export default LanguageToggle;